module.exports = __webpack_public_path__ + "img/background-02.2fa1a84b.png";